import AmexHeader from './AmexHeader';

export default AmexHeader;
